<template>
    <layout-gestao v-cloak>
        <div class="row">
            <div class="col-sm-12">
                <form
                    autocomplete="off"
                    method="post"
                    :disabled="isLoading"
                    data-vv-scope="form"
                    @submit.prevent="onBeforeSaveItem"
                    @keyup.enter="() => {}">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                            <h1 class="content-title">{{ titleItem }}</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-8">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <MaterialTextarea
                                            :readonly="readonlyFormItem"
                                            :disabled="readonlyFormItem"
                                            class="city-form-group city-bg"
                                            id="input-title"
                                            name="title"
                                            v-model.trim="form.title"
                                            :rows="2"
                                            v-validate="'required|min:3|max:100'"
                                            :input-classes="[{'is-invalid': fnHasError(`title`) }]"
                                            :error="fnFirstError(`title`)"
                                            :helpText="`${pageID}.help.title`">
                                            {{ $t(`${pageID}.model.title`) }}
                                        </MaterialTextarea>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <MaterialTextarea
                                            :readonly="readonlyFormItem"
                                            :disabled="readonlyFormItem"
                                            class="city-form-group city-bg"
                                            id="input-subtitle"
                                            name="subtitle"
                                            v-model.trim="form.subtitle"
                                            :rows="3"
                                            v-validate="'min:3|max:500'"
                                            :input-classes="[{'is-invalid': fnHasError(`subtitle`) }]"
                                            :error="fnFirstError(`subtitle`)"
                                            :helpText="`${pageID}.help.subtitle`">
                                            {{ $t(`${pageID}.model.subtitle`) }}
                                        </MaterialTextarea>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="city-label">{{ $t(`${pageID}.model.content`) }}</label>
                                        <div class="city-form-group" :class="{'is-invalid': fnHasError('content') }">
                                            <ckeditor
                                                name="content"
                                                v-model="form.content"
                                                :disabled="readonlyFormItem"
                                                :editor="cKEditor.editor"
                                                :config="cKEditor.editorConfig"
                                                v-validate="'required|min:50'"
                                            />
                                            <small v-if="fnFirstError('content')" class="d-block invalid-feedback">{{ fnFirstError('content') }}</small>
                                            <HelpSpan :helpText="`${pageID}.help.content`" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <UploadMultipleFile
                                        v-model="form.files"
                                        :acceptTypes="acceptTypes"
                                        :maxFiles="maxFiles"
                                        name="files"
                                        v-validate="''"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="row">
                                <div class="col photos">
                                    <div class="form-group">

                                    <div class="row">
                                        <div class="col">
                                            <h6 class="font-weight-normal">{{ $t(`${pageID}.model.thumbnail`) }}</h6>
                                            <hr class="mt-2 mb-0" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="photo">
                                                <UploadSingleImage
                                                    :disabled="readonlyFormItem"
                                                    v-model="form.thumbnail"
                                                    imageClass="background-contain"
                                                    name="thumbnail"
                                                    v-validate="''">
                                                </UploadSingleImage>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <MaterialSelect
                                            :disabled="readonlyFormItem"
                                            class="city-form-group city-bg"
                                            id="input-published"
                                            name="published"
                                            label="name"
                                            :options="lists.onoff"
                                            :reduce="option => option.bool"
                                            v-model.trim="form.published"
                                            v-validate="'required'"
                                            :inputClasses="[{'is-invalid': fnHasError('published') }]"
                                            :error="fnFirstError('published')"
                                            :helpText="`${pageID}.help.published`" >
                                            {{ $t(`${pageID}.model.published`) }}
                                        </MaterialSelect>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <MaterialDateRangePicker
                                            class="city-form-group city-bg"
                                            id="input-period"
                                            :disabled="readonlyFormItem"
                                            name="published_at"
                                            v-model.trim="dateRange"
                                            v-validate="''"
                                            :inputClasses="[{'is-invalid': fnHasError(`published_at`) }]"
                                            :error="fnFirstError(`published_at`)"
                                            :singleDatePicker="true">
                                            {{ $t(`${pageID}.model.published_at`) }}
                                        </MaterialDateRangePicker>
                                    </div>
                                </div>

                                <div class="col-12" v-if="!isSingleLocale">
                                    <div class="form-group">
                                        <MaterialSelect
                                            :disabled="readonlyFormItem"
                                            class="city-form-group city-bg"
                                            id="input-locale"
                                            label="name"
                                            name="locale"
                                            :options="getLocale"
                                            :reduce="option => option.code"
                                            v-model.trim="form.locale"
                                            v-validate="{required:form.locale!=null}"
                                            :inputClasses="[{'is-invalid': fnHasError('locale') }]"
                                            :error="fnFirstError('locale')"
                                            :helpText="`${pageID}.help.locale`" >
                                            {{ $t(`${pageID}.model.locale`) }}
                                        </MaterialSelect>
                                    </div>
                                </div>
                                <div class="col-12" v-if="!isSingleLocale">
                                    <div class="form-group">
                                        <MaterialSelect
                                            id="input-news"
                                            name="news_id"
                                            :disabled="readonlyFormItem"
                                            class="city-form-group city-bg"
                                            label="title"
                                            :options="lists.availabelTranslations"
                                            :reduce="option => option.news_id"
                                            v-model.trim="form.news_id" v-validate="{}"
                                            :inputClasses="[{'is-invalid': fnHasError('news_id') }]"
                                            :error="fnFirstError('news_id')"
                                            :helpText="`${pageID}.help.news`" >
                                            {{ $t(`${pageID}.model.news`) }}
                                        </MaterialSelect>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <MaterialSelect
                                            id="input-news_category_id"
                                            name="news_category_id"
                                            :disabled="readonlyFormItem"
                                            class="city-form-group city-bg"
                                            label="name"
                                            :filterable="true"
                                            :options="lists.categories"
                                            :reduce="option => option.news_category_id"
                                            v-model.trim="form.news.news_category_id"
                                            v-validate="'required'"
                                            :inputClasses="[{'is-invalid': fnHasError('news_category_id') }]"
                                            :error="fnFirstError('news_category_id')"
                                            :helpText="`${pageID}.help.category`" >
                                            {{ $t(`${pageID}.model.category`) }}
                                        </MaterialSelect>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <MaterialSelect
                                            class="city-form-group city-bg"
                                            id="input-roles"
                                            name="roles"
                                            :disabled="readonlyFormItem"
                                            v-model.trim="form.news.roles"
                                            :filterable="false"
                                            :options="lists.roles"
                                            :reduceObject="true"
                                            :multiple="true"
                                            label="name"
                                            v-validate="''"
                                            :inputClasses="[{'is-invalid': fnHasError('roles') }]"
                                            :error="fnFirstError('roles')"
                                            :helpText="`${pageID}.help.roles`" >
                                            {{ $t(`${pageID}.model.roles`) }}
                                        </MaterialSelect>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <MaterialInput
                                            class="city-form-group city-bg"
                                            id="input-order"
                                            name="order"
                                            :disabled="readonlyFormItem"
                                            :readonly="readonlyFormItem"
                                            type="number"
                                            v-model.trim="form.order"
                                            v-validate="'required|integer|min_value:1'"
                                            :inputClasses="[{'is-invalid': fnHasError(`order`) }]"
                                            :error=" fnFirstError(`order`)"
                                            :helpText="`${pageID}.help.order`">
                                            {{ $t(`${pageID}.model.order`) }}
                                        </MaterialInput>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="isDisabled"
                        @save="onBeforeSaveItem"
                        @cancel="handleBack(`${moduleCode}.${pageID}`)"
                    />
                </form>
            </div>
        </div>
    </layout-gestao>
</template>

<script>
    import mixin from '../../mixin';
    import CkEditorConfigMixin from '@/app/shared/mixins/ckeditor/BaseCkEditorConfigMixin';
    import { mapGetters } from 'vuex';

    export default {
        mixins: [
            mixin,
            CkEditorConfigMixin,
        ],
        components: {
            UploadSingleImage: () => import(/* webpackChunkName: "upload-image" */ '@/components/form/UploadSingleImage'),
            UploadMultipleFile: () => import(/* webpackChunkName: "upload-file" */ '@/components/form/UploadMultipleFile'),
            HelpSpan: () => import(/* webpackChunkName: "help-span" */ '@/components/form/HelpSpan'),
        },
        data() {
            return {
                pageID: 'news',
                idUpload: 'uploadInput',
                files: [],
                photos: [],
                dateRange: {
                    startDate: null,
                    endDate: null,
                },
                form: {
                    id: null,
                    title: null,
                    subtitle: null,
                    content: '',
                    slug: null,
                    locale: null,
                    news_id: null,
                    published: false,
                    published_at: null,
                    thumbnail: null,
                    order: 1,
                    files: [],
                    news: {
                        id: null,
                        news_category_id: null,
                        roles: []
                    }
                },
                lists: {
                    translations: [],
                    categories: [],
                    roles: [],
                },
            }
        },
        mounted() {
            this.form.published_at = this.convertDateSI(moment());
            this.form.locale = this.defaultLocale ? this.defaultLocale.code : null;

            if(!this.hasId) {
                this.loadListsOptions();
            }
        },
        computed: {
            ...mapGetters('geoportalgestao', {
                maxFiles: 'getMaxFiles',
                acceptTypes: 'getMimeTypesAllowed',
            }),
        },
        methods: {
            loadListsOptions() {
                let params = {
                    locale: this.form.locale,
                };

                this.loadLists(this.urlLists(), params)
                .then( res => {
                    if(!res) return;

                    // codigo que existia que não percebo!!
                    // if(this.form.news.translations) {
                    //     let translationFounded = false;
                    //     this.form.news.translations.forEach(translation => {
                    //         if(translation.locale != this.form.locale && translation.id != this.form.id) {
                    //             this.lists.translations.push(translation);
                    //             translationFounded = true;
                    //         }
                    //     });
                    //     if(translationFounded) {
                    //         this.lists.translations.push({news_id: '', title: 'Sem tradução'});
                    //     } else {
                    //         let news_id = this.form.news_id || '';
                    //         this.lists.translations.push({news_id, title: 'Sem tradução'});
                    //     }
                    // }
                });
            },
            callbackLoadItem: function () {
                this.loadListsOptions();

                // this.files = [];
                // if(this.form.files) {
                //     this.form.files.forEach(file => {
                //         this.files.push({
                //             id: file.id,
                //             path: file.path,
                //             name: file.name
                //         });
                //     });
                // }
            },
            onBeforeSaveItem: function(fallback=false) {
                this.saveItem(null);
            },
            convertDateSI(date) {
                return moment(date).format('YYYY-MM-DD')
            },
            convertDateLocale(date) {
                return moment(date+' 00:00:00').format('YYYY-MM-DDTHH:mm:ssZ');
            },
            forceDirty: function(field){
                if(this.fields.$form && this.fields.$form[field]){
                    this.fields.$form[field].dirty=true;
                }
            },
        },
        watch: {
            'form.locale': function(newValue, oldValue) {
                if(newValue != oldValue && oldValue) {
                    this.loadListsOptions();
                }
            },
            'form.published_at': function(newValue, oldValue) {
                if(this.convertDateSI(newValue) != this.convertDateSI(this.dateRange.startDate))
                    this.dateRange = {startDate: (this.convertDateLocale(newValue)), endDate: (this.convertDateLocale(newValue))};
            },
            'dateRange.startDate': function(newValue) {
                this.form.published_at = this.convertDateSI(newValue);
            },
            'photos': {
                handler() { this.forceDirty('thumbnail'); },
                deep: true
            },
            'files': {
                handler() { this.forceDirty('files'); },
                deep: true
            }
        },
    }
</script>

<style scoped lang="scss">
    .photos .photo {
        height: 175px;
    }
</style>
